import React, { useState } from 'react';
import {
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Toolbar,
  Typography,
  Tooltip
} from '@mui/material';


import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';

import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import BloodtypeIcon from '@mui/icons-material/Bloodtype';
import ChatIcon from '@mui/icons-material/Chat';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import ScienceIcon from '@mui/icons-material/Science';
import CategoryIcon from '@mui/icons-material/Category';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import DescriptionIcon from '@mui/icons-material/Description';

const drawerWidth = 240;
const collapsedWidth = 72;
type SidebarProps = {
    collapsed: boolean;
  };
export default function Sidebar({ collapsed }: SidebarProps) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
      <Drawer
        variant="permanent"
        sx={{
          width: collapsed ? collapsedWidth : drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: collapsed ? collapsedWidth : drawerWidth,
            boxSizing: 'border-box',
            transition: 'width 0.3s ease',
            backgroundColor: '#002244',
            color: '#fff',
          },
        }}
      >
        <Toolbar />
        <Divider />
        <List>
          {[
            { id: 1, text: 'Dashboard', icon: <Tooltip title="Dashbaord" arrow><DashboardIcon /></Tooltip>, route:"/dashboard" },
            { id: 2, text: 'Bio File(Patients)', icon: <Tooltip title="Bio File(Patients)" arrow><LocalHospitalIcon /></Tooltip>, route:"/patients" },
            { id: 3, text: 'Patient Diagnostics', icon: <Tooltip title="Patient Diagnostics" arrow><BloodtypeIcon /></Tooltip>, route:"/patient-diagnostics" },
            { id: 4, text: 'Patient Reports', icon: <Tooltip title="Patient Reports" arrow><DescriptionIcon /></Tooltip>, route:"/patient-reports" },
            { id: 5, text: 'Test Groups', icon: <Tooltip title="Test Groups" arrow><CategoryIcon /></Tooltip>, route:"/test-groups" },
            { id: 6, text: 'Lab Test(s)', icon: <Tooltip title="Lab Test(s)" arrow><VaccinesIcon /></Tooltip>, route:"/lab-tests" },
            { id: 7, text: 'Lab Matrix', icon: <Tooltip title="Lab Matrix" arrow><ScienceIcon /></Tooltip>, route:"/lab-matrix" },
            { id: 8, text: 'Billing', icon: <Tooltip title="Billing" arrow><AttachMoneyIcon /></Tooltip>, route:"/billing" },
            { id: 9, text: 'Query Box', icon: <Tooltip title="Query Box" arrow><ChatIcon /></Tooltip>, route:"/query-box" },
            { id: 10, text: 'Settings', icon: <Tooltip title="Settings" arrow><SettingsIcon /></Tooltip>, route:"/settings" },
          ].map(({ id, text, icon, route }) => (
            <ListItem key={id} disablePadding sx={{ display: 'block' }}>
              <ListItemButton
                selected={location.pathname === route}
                sx={{
                  minHeight: 35,
                  justifyContent: collapsed ? 'center' : 'initial',
                  px: 2.5,
                  backgroundColor: location.pathname === route ? 'rgba(255, 255, 255, 0.08)' : 'inherit',
                  '&.Mui-selected': {
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.25)',
                    },
                  },
                }}
                onClick={() => navigate(route)}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: collapsed ? 'auto' : 2,
                    justifyContent: 'center',
                    color: 'inherit',
                  }}
                >
                  {icon}
                </ListItemIcon>
                {!collapsed && (
                  <Typography variant="body1" sx={{ color: 'white' }}>
                    {text}
                  </Typography>
                )}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
  );
}
